'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _Status = require('./Status.js');

var _Status2 = _interopRequireDefault(_Status);

var _CachedStatus = require('./CachedStatus.js');

var _CachedStatus2 = _interopRequireDefault(_CachedStatus);

var _CurrencyUtils = require('../CurrencyUtils.js');

var _CurrencyUtils2 = _interopRequireDefault(_CurrencyUtils);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Order = require('./Order');

var _Order2 = _interopRequireDefault(_Order);

var _ChargeV = require('./ChargeV2');

var _ChargeV2 = _interopRequireDefault(_ChargeV);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChargesByTypes(chargesV2) {
    // First, group charges by type -
    // - itemCharges:    Amount or percentage off item.
    //                   This type of discount is independent, thus can be ran
    //                   against a single order item without any issue.
    // - orderDiscounts: Amount off order. This type of discount must be applied for
    //                   the entire order, and then divided by the weight of the
    //                   item in question, relative to the entire order
    // - taxes -         Taxes should be calculated last, since we apply them only
    //                   after all discounts are applied.

    var charges = {
        itemDiscounts: [],
        orderDiscounts: [],
        taxes: []
    };

    chargesV2.forEach(function (charge) {
        var type = _ChargeV2.default.getChargeType({ charge: charge });
        if (type === 'tax') {
            charges.taxes.push(charge);
        } else if (type === 'percentDiscount' || type === 'fixedDiscount') {
            charges.itemDiscounts.push(charge);
        } else if (type === 'fixedOneTimeDiscount') {
            charges.orderDiscounts.push(charge);
        }
    });

    return charges;
}

function sumPrices(order, ids) {
    var operator = {
        type: 'sum_prices',
        items: {
            type: 'include',
            ids: ids
        }
    };

    return _ChargeV2.default.calculateOperator({
        operator: operator,
        orderItems: order.orderItems
    });
}

function extractRelevantIdsFromOffOrderDiscount(discount) {
    return discount.operator.operators[1].denominators[0].denominators[0].items.ids;
}

function calcAmountRelativeToEntireDiscount(_ref) {
    var order = _ref.order,
        total = _ref.total,
        charge = _ref.charge,
        itemPrice = _ref.itemPrice;

    var relativeOperator = {
        type: 'multiply',
        numerators: [{
            type: 'multiply',
            numerators: [{ type: 'value', value: itemPrice }, { type: 'value', value: 1000 }],
            denominators: [{ type: 'value', value: total }]
        }, { type: 'value', value: charge.amount }],
        denominators: [{ type: 'value', value: 1000 }]
    };

    return _ChargeV2.default.calculateOperator({
        operator: relativeOperator,
        orderItems: order.orderItems
    });
}

function getOffOrderCharges(_ref2) {
    var order = _ref2.order,
        orderItem = _ref2.orderItem,
        orderDiscounts = _ref2.orderDiscounts,
        timezone = _ref2.timezone;

    var allOffOrderCharges = _Order2.default.getOrderCharges({ order: order, chargesV2: orderDiscounts, timezone: timezone });

    var relevantCharges = allOffOrderCharges.filter(function (charge) {
        var orderDiscount = orderDiscounts.find(function (od) {
            return od.id === charge.chargeId;
        });
        var idsFilter = orderDiscount.operator.operators[0].numerators[0].items;
        return _ChargeV2.default.isApplicableItem(orderItem.itemId, idsFilter);
    });

    var result = relevantCharges.map(function (charge) {
        var complex = orderDiscounts.find(function (o) {
            return o.id === charge.chargeId;
        });
        var total = sumPrices(order, extractRelevantIdsFromOffOrderDiscount(complex));
        var itemPrice = sumPrices({ orderItems: [orderItem] }, [orderItem.itemId]);
        var relative = calcAmountRelativeToEntireDiscount({ order: order, total: total, charge: charge, itemPrice: itemPrice });

        return {
            chargeId: complex.id,
            amount: relative
        };
    });

    return _lodash2.default.compact(result);
}

function getItemTaxCharges(_ref3) {
    var taxes = _ref3.taxes,
        order = _ref3.order,
        orderItem = _ref3.orderItem,
        deliveryTime = _ref3.deliveryTime,
        orderCharges = _ref3.orderCharges;

    return taxes.map(function (tax) {
        return {
            chargeId: tax.id,
            amount: _ChargeV2.default.calculateAmount({
                charge: tax,
                deliveryTime: deliveryTime,
                deliveryType: order.delivery.type,
                source: order.source,
                platform: order.platform,
                orderItems: [orderItem],
                orderCharges: orderCharges
            })
        };
    });
}

exports.default = {
    getStatus: function getStatus(item, time) {
        return _Status2.default.getStatus(item.availability, time);
    },
    getItemImage: function getItemImage(_ref4) {
        var item = _ref4.item,
            size = _ref4.size,
            distributor = _ref4.distributor,
            refresh = _ref4.refresh;

        if (!item.picture) {
            return distributor.getNoImageUrl(size);
        }

        var ret = item.picture;
        if (size) {
            ret += "=s" + parseInt(size);
        };
        if (refresh) {
            ret += "?time=" + new Date().getTime();
        }
        return ret;
    },
    doesFitOrderMinimum: function doesFitOrderMinimum(_ref5) {
        var item = _ref5.item,
            orderCost = _ref5.orderCost;

        for (var i in item.labels) {
            var label = item.labels[i];
            if (label.indexOf('minimal_order') > -1) {
                var minimum = parseInt(label.substring(10));
                if (minimum > orderCost) return false;
            }
        }

        return true;
    },
    getPriceRange: function getPriceRange(_ref6) {
        var item = _ref6.item,
            menu = _ref6.menu,
            useSimplifiedItems = _ref6.useSimplifiedItems,
            itemsHash = _ref6.itemsHash;

        var itemsMap = itemsHash || _lodash2.default.reduce(useSimplifiedItems ? menu.simplifiedItems : menu.items, function (rc, item) {
            rc[item.id] = item;
            return rc;
        }, {});

        var pricer = new ItemPricer({ itemsMap: itemsMap });
        return pricer.getPriceRange(item);
    },
    getPriceStr: function getPriceStr(_ref7) {
        var item = _ref7.item,
            currency = _ref7.currency,
            menu = _ref7.menu,
            priceRangeConf = _ref7.priceRangeConf,
            useSimplifiedItems = _ref7.useSimplifiedItems,
            itemsHash = _ref7.itemsHash,
            locale = _ref7.locale;


        var priceRange = this.getPriceRange({ item: item, menu: menu, useSimplifiedItems: useSimplifiedItems, itemsHash: itemsHash });

        // If price range should display top/bottom, return these.
        if (priceRangeConf === 'top') {
            if (!priceRange.max) return '';
            return _CurrencyUtils2.default.toStr(priceRange.max / 100, currency, locale);
        } else if (priceRangeConf === 'bottom') {
            if (!priceRange.min) return '';
            return _CurrencyUtils2.default.toStr(priceRange.min / 100, currency, locale);
        }

        if (priceRange.min === priceRange.max) {
            if (!priceRange.max) return '';
            return _CurrencyUtils2.default.toStr(priceRange.min / 100, currency, locale);
        } else {
            // if (!item.price) { return ''; } // If item price is 0, and we're range only because of
            // the variations, show the prices only in the variations

            if (priceRange.range) {
                if (priceRange.min * 10 < priceRange.max) {
                    // randomly selected multiplier :)
                    return _CurrencyUtils2.default.toStr(priceRange.min / 100, currency, locale) + '+';
                } else {
                    return _CurrencyUtils2.default.toStr(priceRange.min / 100, currency, locale) + ' - ' + _CurrencyUtils2.default.toStr(priceRange.max / 100, currency, locale);
                }
            } else {
                return _CurrencyUtils2.default.toStr(priceRange.min / 100, currency, locale) + ' / ' + _CurrencyUtils2.default.toStr(priceRange.max / 100, currency, locale);
            }
        }
    },
    isSoldOut: function isSoldOut(item, orderTime) {
        var status = _CachedStatus2.default.getStatusForItem({
            item: item,
            time: orderTime
        });

        if (status.status === 'unavailable' && status.reason === 'soldout') return true;

        if (!item.stock) return false;

        if (item.stock.count === null) return false;

        if (item.stock.count > 0) return false;

        return true;
    },
    isUnavailable: function isUnavailable(item, orderTime) {
        var status = _CachedStatus2.default.getStatusForItem({
            item: item,
            time: orderTime
        });

        if (status.status === 'unavailable') return true;

        return false;
    },
    getItemCharges: function getItemCharges(_ref8) {
        var orderItem = _ref8.orderItem,
            order = _ref8.order,
            _ref8$chargesV = _ref8.chargesV2,
            chargesV2 = _ref8$chargesV === undefined ? [] : _ref8$chargesV,
            timezone = _ref8.timezone;

        var deliveryTime = (0, _moment2.default)(order.delivery.time).tz(timezone);

        var _getChargesByTypes = getChargesByTypes(chargesV2),
            itemDiscounts = _getChargesByTypes.itemDiscounts,
            orderDiscounts = _getChargesByTypes.orderDiscounts,
            taxes = _getChargesByTypes.taxes;

        var singleItemOrder = (0, _extends3.default)({}, _lodash2.default.cloneDeep(order), {
            orderItems: [orderItem]
        });

        // Calculate amount/percentage off item discounts,
        // calculation is straight forward, as it is independent from order
        var offItemCharges = _Order2.default.getOrderCharges({ order: singleItemOrder, chargesV2: itemDiscounts, timezone: timezone });

        // Calculate amount off order discounts
        var offOrderCharges = getOffOrderCharges({ order: order, orderItem: orderItem, orderDiscounts: orderDiscounts, timezone: timezone });

        // After all discounted are calculated, it is time to apply taxes
        var taxCharges = getItemTaxCharges({
            taxes: taxes,
            order: order,
            orderItem: orderItem,
            deliveryTime: deliveryTime,
            orderCharges: [].concat((0, _toConsumableArray3.default)(offItemCharges), (0, _toConsumableArray3.default)(offOrderCharges))
        });

        return [].concat((0, _toConsumableArray3.default)(offItemCharges), (0, _toConsumableArray3.default)(offOrderCharges), (0, _toConsumableArray3.default)(taxCharges));
    }
};

//****************************** ITEM PRICER ***********************************

var ItemPricer = function ItemPricer() {
    var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref9$itemsMap = _ref9.itemsMap,
        itemsMap = _ref9$itemsMap === undefined ? {} : _ref9$itemsMap;

    // "Let the following diagram be a warning to whoever is thinking of changing this class."
    //
    // item -- "5-8"
    // |
    // | v1 -- "5-8"
    // |----|
    // |    | i1 (0) -- "6-12"
    // |    |----|
    // |    |    |  v3 -- "3-6"
    // |    |    |----|
    // |    |    |    |  i5 (3) --- "3-3"
    // |    |    |    |----
    // |    |    |    |
    // |    |    |    |  i6 (6) --- "6-6"
    // |    |    |    |----
    // |    |    |
    // |    |    |
    // |    |    |
    // |    |    |  v3 -- "3-6"
    // |    |    |----|
    // |    |         |  i5 (3) --- "3-3"
    // |    |         |----
    // |    |         |
    // |    |         |  i6 (6) --- "6-6"
    // |    |         |----
    // |    |
    // |    |
    // |    |
    // |    | i2 (2) --- "2-2"
    // |    |---
    // |
    // |
    // |
    // |
    // | v2 -- "0-0"
    // |----
    //      | i3 (0) --- "0-0"
    //      |---
    //      |
    //      | i4 (2) --- "2-2"
    //

    var self = {};

    var skipPriceRange = false; // This is done for protection against circular dependencies. If we
    // discover a circular dependency we stop doing the price-range calculation
    //                          // since they take much of the CPU

    self.getPriceRange = function (item) {
        var basePrice = item.price || 0;

        if (skipPriceRange) {
            return { min: basePrice, max: basePrice, range: false };
        }

        try {
            return calculateItemPriceRange(item, basePrice, []);
        } catch (e) {
            console.warn('Circular dependency. Skipping price range');
            skipPriceRange = true;
            return { min: basePrice, max: basePrice, range: false };
        }
    };

    function calculateItemPriceRange(item, basePrice, itemPath) {
        var priceRange = { min: basePrice, max: basePrice, range: false };

        var numNonTrivialRanges = 0;
        _lodash2.default.each(item.variations, function (variation) {
            var variationPriceRange = calculateVariationPriceRange(variation, itemPath);
            //        	console.log(variation.title.en_US + " -> " + JSON.stringify(variationPriceRange));
            if (variationPriceRange.min !== variationPriceRange.max) {
                ++numNonTrivialRanges;
            }
            priceRange.min += variationPriceRange.min;
            priceRange.max += variationPriceRange.max;
            priceRange.range = priceRange.range || variationPriceRange.range;
        });
        if (numNonTrivialRanges > 1) {
            priceRange.range = true;
        }

        if (priceRange.min === 0) {
            priceRange.max = 0;
            priceRange.range = false;
        }
        return priceRange;
    }

    function calculateVariationPriceRange(variation, itemPath) {
        var minNumAllowed = variation.minNumAllowed || 0;
        var prices = variation.prices || {};
        switch (minNumAllowed) {
            case 0:
                return { min: 0, max: 0, range: false };
            case 1:
                {
                    // HACK: multi-item support is kinda messed up
                    var priceRange = { min: Number.POSITIVE_INFINITY, max: 0, range: false };

                    var numNonTrivialRanges = 0;
                    _lodash2.default.each(variation.itemIds, function (itemId) {
                        var item = itemsMap[itemId.itemId];
                        if (!item) {
                            return;
                        }

                        var price = prices[itemId.itemId] ? prices[itemId.itemId][1] : 0;

                        if (_lodash2.default.includes(itemPath, itemId.itemId)) {
                            throw new Error('Circular dependency');
                        } else {
                            var newItemPath = _lodash2.default.union({}, itemPath, [itemId.itemId]);
                            var itemPriceRange = calculateItemPriceRange(item, price, newItemPath);
                        }
                        //                    	console.log(item.title.en_US + " -> " + JSON.stringify(itemPriceRange));
                        if (itemPriceRange.min !== 0 || itemPriceRange.min !== itemPriceRange.max) {
                            ++numNonTrivialRanges;
                        }
                        priceRange.min = Math.min(priceRange.min, itemPriceRange.min);
                        priceRange.max = Math.max(priceRange.max, itemPriceRange.max);
                        priceRange.range = priceRange.range || itemPriceRange.range;
                    });
                    if (numNonTrivialRanges > 1) {
                        priceRange.range = true;
                    }
                    if (priceRange.min === 0) {
                        priceRange.max = 0;
                        priceRange.range = false;
                    }
                    return priceRange;
                }
            default:
                // More complex cases are not implemented
                return { min: 0, max: 0, range: false };
        }
    }

    return self;
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/Item.js
// module id = 286
// module chunks = 0